/**
 * @generated SignedSource<<84997c1d3456fe157940ab9424e3f14f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BulkOperationResultDisplay_bulkOperationResult$data = {
  readonly failureCodes: ReadonlyArray<{
    readonly failureCode: string | null;
    readonly itemId: string | null;
  } | null> | null;
  readonly itemsFailed: ReadonlyArray<{
    readonly projects: ReadonlyArray<{
      readonly name: string | null;
      readonly serviceId: string | null;
    } | null> | null;
    readonly serviceId: string | null;
    readonly title: string | null;
  } | null> | null;
  readonly itemsSucceeded: ReadonlyArray<{
    readonly hasRequestedHoldForBuyer: boolean | null;
    readonly projects: ReadonlyArray<{
      readonly name: string | null;
      readonly serviceId: string | null;
    } | null> | null;
    readonly serviceId: string | null;
    readonly title: string | null;
  } | null> | null;
  readonly " $fragmentType": "BulkOperationResultDisplay_bulkOperationResult";
};
export type BulkOperationResultDisplay_bulkOperationResult$key = {
  readonly " $data"?: BulkOperationResultDisplay_bulkOperationResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"BulkOperationResultDisplay_bulkOperationResult">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "userId",
      "variableName": "userId"
    }
  ],
  "concreteType": "Project",
  "kind": "LinkedField",
  "name": "projects",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BulkOperationResultDisplay_bulkOperationResult",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "itemsSucceeded",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            }
          ],
          "kind": "ScalarField",
          "name": "hasRequestedHoldForBuyer",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "itemsFailed",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemRequestFailureCode",
      "kind": "LinkedField",
      "name": "failureCodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "itemId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "failureCode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BulkOperationResult",
  "abstractKey": "__isBulkOperationResult"
};
})();

(node as any).hash = "869efcf2e8fc500f3f2ab7912f7fbc07";

export default node;
